import router from '@/router'
import { Notification } from 'element-ui'
import alarmIcon from '@/assets/imgs/icon/alarm-push.png'
import alarmScreenIcon from '@/assets/imgs/icon/alarm-push-screen.png'
import mp3 from '@/assets/audio/620.mp3'
import { isProd } from '@/config'
import { apiGetStaffConfigs } from '@/apis/tenant.api.js'
import { setInterval } from 'core-js'
let audio = null

export default {
	state: {
		websocket: null,
		timer: null,
		serverTimer: null,
		alarmCount: 0, // 告警数量
		updateApiTimes: 0,
		isLock: false,
		notifyList: [], // 当前弹屏列表
		soundDuration: 10, // 告警时长
		popupOffHours: 0, // 弹窗失效时长(小时),0表示不关闭弹窗
		popupOffStart: 0, // 弹窗失效开始时间戳
		soundTimer: null, // 循环播放告警定时器
		audioDuration: 2000, // 音频播放间隔,默认2000毫秒
		boardUpdate: false, //运行看板是否更新
	},
	getters: {
		websocket: state => state.websocket,
		alarmCount: state => state.alarmCount,
		updateApiTimes: state => state.updateApiTimes,
		boardUpdate: state => state.boardUpdate,
		soundDuration: state => state.soundDuration,
		popupOffHours: state => state.popupOffHours,
		// 弹窗恢复时间戳,0表示未关闭弹窗
		popupOffUntil: state => (state.popupOffHours ? state.popupOffStart + state.popupOffHours * 60 * 60 * 1000 : 0),
	},
	mutations: {
		SET_ALARM_COUNT(state, payload) {
			state.alarmCount = payload
		},
		SET_SOUND_DURATION(state, payload) {
			state.soundDuration = Number(payload)
		},
		SET_POPUP_OFF(state, { hours, start }) {
			state.popupOffHours = Number(hours)
			state.popupOffStart = Number(start)
		},
		SET_BOARD_UPDATE(state, payload) {
			state.boardUpdate = payload
		},
	},
	actions: {
		// 模拟告警推送
		mockAlarmPush({ dispatch }) {
			const data = {
				alarmCount: 1,
				sessionKey: '100389_0',
				alarmTime: '2025-08-11 14:27:45',
				alarmName: '测试告警名称',
				addressName: '杭州市金卡智能',
				deviceName: '安可信报警器-子设备',
				soundAlarm: false,
				deviceId: 471210,
				deviceTypeId: 2012,
			}
			setTimeout(() => {
				dispatch('showAlarmNotify', data)
			}, 1000)
		},

		// 获取告警时长配置
		getSoundDuration({ commit, rootGetters }) {
			return new Promise((resolve, reject) => {
				apiGetStaffConfigs({
					tenantId: rootGetters.userInfo?.tenantId,
					staffId: rootGetters.userInfo?.staffId,
					key: 'alarm_sound_duration',
				})
					.then(data => {
						commit('SET_SOUND_DURATION', data)
						resolve(data)
					})
					.catch(err => {
						reject(err)
					})
			})
		},

		// 获取弹窗失效时长配置
		getPopupOff({ commit, rootGetters }) {
			const params = {
				tenantId: rootGetters.userInfo?.tenantId,
				staffId: rootGetters.userInfo?.staffId,
			}
			return Promise.all([
				apiGetStaffConfigs({ ...params, key: 'alarm_popup_off_hours' }),
				apiGetStaffConfigs({ ...params, key: 'alarm_popup_off_start' }),
			]).then(([hours, start]) => {
				commit('SET_POPUP_OFF', { hours, start })
			})
		},

		initWebSocket({ state, commit, dispatch, rootGetters }) {
			let { tenantId, isolationOrgCode = 'default', staffId } = rootGetters.userInfo || {}
			const { host: _host, protocol: _protocol } = window.location
			if (!isProd && !tenantId) tenantId = 100022
			const host = isProd ? _host : 'test1129.iot.cn'
			const protocol = _protocol === 'http:' ? 'ws' : 'wss'
			const url = `${protocol}://${host}/monitor/alarm-push/${tenantId}/${isolationOrgCode}/${staffId}`
			const clearHeartCheck = () => {
				clearTimeout(state.timer)
				clearTimeout(state.serverTimer)
				state.timer = null
				state.serverTimer = null
			}

			const startHeartCheck = websocket => {
				clearHeartCheck()
				state.timer = setTimeout(() => {
					if (state.websocket !== websocket || websocket.readyState !== WebSocket.OPEN) return

					websocket.send('ping')
					state.serverTimer = setTimeout(() => {
						if (state.websocket === websocket && websocket.readyState === WebSocket.OPEN) {
							websocket.close()
						}
					}, 30000)
				}, 30000)
			}

			const initEventHandler = websocket => {
				websocket.onopen = () => {
					if (state.websocket !== websocket) return
					console.log('连接建立成功')
					startHeartCheck(websocket)
				}
				// 监听服务端消息(接收消息)
				websocket.onmessage = e => {
					if (state.websocket !== websocket) return
					console.log('接收服务端返回数据', e)
					startHeartCheck(websocket)
					if (typeof e.data === 'string' && e.data.indexOf('alarmCount') > -1) {
						const data = JSON.parse(e.data)
						console.log('%c [ data ]-122', 'font-size:13px; background:pink; color:#bf2c9f;', data)
						const { alarmCount, alarmName } = data
						commit('SET_ALARM_COUNT', alarmCount)
						if (alarmCount && alarmName) {
							if (state.notifyList.length > 4) {
								const instance = state.notifyList.shift()
								instance.close()
							}
							dispatch('showAlarmNotify', data)
						}
					}
					// dispatch("mockAlarmPush");
				}
				// 监听连接失败重连
				websocket.onerror = () => {
					if (state.websocket !== websocket) return
					console.log('连接建立失败')
					websocket.close()
				}
				// 监听连接关闭
				websocket.onclose = () => {
					if (state.websocket !== websocket) return
					state.websocket = null
					clearHeartCheck()
				}
			}

			const createWebsocket = () => {
				const { websocket } = state
				if (
					websocket &&
					[WebSocket.CONNECTING, WebSocket.OPEN, WebSocket.CLOSING].includes(websocket.readyState)
				) {
					return
				}

				try {
					const nextWebsocket = new WebSocket(url)
					state.websocket = nextWebsocket
					initEventHandler(nextWebsocket)
				} catch (error) {
					console.error('告警 WebSocket 创建失败', error)
				}
			}

			createWebsocket()
		},
		showAlarmNotify({ state, getters, dispatch, commit }, data) {
			if (!state.isLock) {
				state.updateApiTimes += 1
				state.isLock = true
				setTimeout(() => {
					state.isLock = false
				}, 60 * 1000)
			}
			//当前为运行看板页面
			if (router.app._route.path === '/run/run-board') {
				commit('SET_BOARD_UPDATE', true)
			}
			// 弹窗失效时长内不弹窗、不播放声音
			if (Date.now() < getters.popupOffUntil) return

			const {
				alarmName,
				deviceName = '--',
				alarmTime = '--',
				addressName = '--',
				soundAlarm = false,
				deviceId,
				deviceTypeId,
			} = data
			if (soundAlarm && state.soundDuration) {
				dispatch('stopAudio')
				dispatch('playAudio')
			}
			let showClose = true,
				customClass = 'box-notify',
				icon = alarmIcon,
				duration = 0
			// 当前为大屏页面
			if (router.app._route.path === '/big-screen') {
				// showClose = false;
				customClass = 'box-notify screen'
				icon = alarmScreenIcon
				// duration = 5000;
			}
			const instance = Notification({
				title: alarmName,
				dangerouslyUseHTMLString: true,
				message: `
        <div class="content">
          <div class="box-icon"><img class="icon" src="${icon}" /></div>
          <div class="info">
            <h3 class="name">${deviceName}</h3>
            <p class="time">${alarmTime}</p>
            <p class="address">${addressName}</p>
          </div>
        </div>`,
				duration,
				customClass,
				showClose,
				onClose: e => {
					const instanceIndex = state.notifyList.findIndex(item => item.id === e.id)
					if (instanceIndex !== -1) {
						state.notifyList.splice(instanceIndex, 1)
					}
					if (!state.notifyList?.length) {
						dispatch('stopAudio')
						clearInterval(state.soundTimer)
					}
				},
				onClick() {
					router.push({
						name: 'deviceDetail',
						query: {
							deviceId: deviceId,
							deviceType: deviceTypeId,
						},
						params: {
							name: 'AlarmRecord',
						},
					})
				},
			})
			state.notifyList.push(instance)
		},
		clearWebSocket({ state }) {
			clearTimeout(state.timer)
			clearTimeout(state.serverTimer)
			state.timer = null
			state.serverTimer = null

			const { websocket } = state
			state.websocket = null
			if (websocket) {
				websocket.onopen = null
				websocket.onmessage = null
				websocket.onerror = null
				websocket.onclose = null
				websocket.close()
			}
		},
		// 循环播放音频
		handleSoundDuration({ state }) {
			clearInterval(state.soundTimer)
			const { soundDuration, audioDuration } = state
			const duration = soundDuration * 60 * 1000
			if (duration <= audioDuration) return
			// 初始化当前播放音频时间
			let currentDuration = audioDuration
			state.soundTimer = setInterval(() => {
				if (currentDuration < duration) {
					// 当前播放时间小于设置时间,继续播放且增加当前播放时间
					audio.play()
					currentDuration += audioDuration
				} else {
					clearInterval(state.soundTimer)
				}
			}, audioDuration)
		},
		//播放音频
		playAudio({ state, dispatch }) {
			audio = new Audio()
			audio.src = mp3
			audio.play()
			audio.oncanplay = function () {
				// 获取音频时长 + 200毫秒作为循环播放间隔时间
				const duration = Math.ceil(audio.duration * 1000) + 200
				state.audioDuration = duration
			}
			dispatch('handleSoundDuration')
		},
		//停止音频
		stopAudio() {
			audio && audio.pause()
		},
	},
}
